var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"none-bg",attrs:{"id":"error"}},[_c('div',{staticClass:"none-tips"},[_vm._v(" 暂无权限，请通过平台登录查看 ")])])}]

export { render, staticRenderFns }